import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUser } from '@/models'

type UserStateType = {
  data: IUser | null
  isLoaded: boolean
  isError: boolean
  isRector: boolean
  isTopManager: boolean
}

const initialState: UserStateType = {
  data: null,
  isLoaded: false,
  isError: false,
  isRector: false,
  isTopManager: false
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUpdateUser(state, action: PayloadAction<IUser | null>) {
      state.data = action.payload
      state.isLoaded = true
    },
    setUserIsRector(state, action: PayloadAction<boolean>) {
      state.isRector = action.payload
      state.isLoaded = true
    },
    setUserIsTopManager(state, action: PayloadAction<boolean>) {
      state.isTopManager = action.payload
      state.isLoaded = true
    },
    setUserError(state, action: PayloadAction<boolean>) {
      state.isError = action.payload
      state.isLoaded = true
    }
  }
})

export const { setUpdateUser, setUserError, setUserIsRector, setUserIsTopManager } = userSlice.actions

export default userSlice.reducer
